import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)
const routes: Array<RouteConfig> = [
  {
    path: '/detail/:id.html',
    name: 'Article',
    component: () => import('@/views/article/index.vue'),
  },
  {
    path: '/rank',
    name: 'Rank',
    component: () => import('@/views/rank/index.vue'),
  },
  {
    path: '/preview/:id.html',
    name: 'Preview',
    component: () => import('@/views/preview/index.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/community/' : '',
  routes,
})

export default router
